module.exports = __webpack_public_path__ + "img/flatfish.c7c82b2a.png";